/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-form-field[_ngcontent-%COMP%]{width:100%;margin-bottom:-.85em}.styled-form[_ngcontent-%COMP%]{border:1px solid #000;border-radius:8px}.selected-values[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;margin-top:10px;gap:8px}.selected-values[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background-color:#e0e0e0;border-radius:4px;padding:5px 10px;font-size:14px;display:flex;align-items:center}.checkmark[_ngcontent-%COMP%]{color:green;margin-right:4px}"];
export { styles as styles };
